import React from 'react';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import DoneIcon from '@material-ui/icons/Done';
import clsx from 'clsx';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CloseIcon from '../SvgElements/CloseIcon';
import RightArrow from '../SvgElements/RightArrow';

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
});

const AirbnbSlider = withStyles({
  root: {
    color: 'rgb(245, 0, 87)',
    height: 3,
    padding: '13px 0',
    marginTop: 12,
  },
  thumb: {
    height: 27,
    width: 27,
    backgroundColor: '#fff',
    border: '1px solid currentColor',
    marginTop: -12,
    marginLeft: -13,
    boxShadow: '#ebebeb 0px 2px 2px',
    '&:focus, &:hover, &$active': {
      boxShadow: '#ccc 0px 2px 3px 1px',
    }
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 7,
  },
  rail: {
    color: '#d8d8d8',
    opacity: 1,
    height: 3,
  },
})(Slider);

function AirbnbThumbComponent(props) {
  return (
    <span {...props}>
      <span className="bar" />
      <span className="bar" />
      <span className="bar" />
    </span>
  );
}
const PrettoSlider = withStyles({
  root: {
    color: 'rgb(245, 0, 87)',
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

function lowPriceComparator(a,b) {
  return a.dailyPrice - b.dailyPrice
}

function highPriceComparator(a,b) {
  return  b.dailyPrice- a.dailyPrice
}

//homes.sort(mycomparator);

export default function(props){
  const rate = parseFloat(props.userPack.elements.currency.rates[props.userPack.elements.currency.selected]).toFixed(2)
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [priceRange, setPriceRange] = React.useState([props.userPack.filters.priceRange[0]*(rate/rate),props.userPack.filters.priceRange[1]*(rate/rate)])
  const [priceMaximum, setPriceMaximum] = React.useState([0,props.userPack.filters.priceMaximum[1]]);
  const [deliveryFee, setDeliveryFee] = React.useState(20);
  const handleClose =()=>{
      let popOver = props.userPack.popOver
      popOver.open = false
      props.userPack.setPopOver(popOver)

      let newFilters = props.userPack.filters
      newFilters.active=false
      props.userPack.filterMethods.handleFilters(newFilters)
    }
    const classes = useStyles();
    const toggleDrawer = (open) => event => {
      if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }
      let newFilters = props.userPack.filters
      newFilters.active = open
      props.userPack.filterMethods.handleFilters(newFilters)
    };
    const handleClear =()=>{
      let newFilters = {priceRange:[30,200],priceMaximum:[0,300],sortBy:null,deliveryFee:30,map:true}
      props.userPack.filterMethods.handleFilters(newFilters)
      props.userPack.filterMethods.setFilteredResults(null)
    }
    const filterHighPrice =()=>{
      let newFilters = props.userPack.filters
      newFilters.sortBy = 'high'
      props.userPack.filterMethods.handleFilters(newFilters)
      let filteredResults = props.userPack.results.sort(highPriceComparator)
      props.userPack.filterMethods.setFilteredResults(filteredResults)
    }
    const filterLowPrice =()=>{
      let newFilters = props.userPack.filters
      newFilters.sortBy = 'low'
      props.userPack.filterMethods.handleFilters(newFilters)
      let filteredResults = props.userPack.results.sort(lowPriceComparator)
      props.userPack.filterMethods.setFilteredResults(filteredResults)
    }
    const filterRelevancia =()=>{
      let newFilters = props.userPack.filters
      newFilters.sortBy = null
      props.userPack.filterMethods.handleFilters(newFilters)
      props.userPack.filterMethods.setFilteredResults(null)
    }
    const handlePrice =(e,priceRange)=>{
      // let newFilters = {...props.userPack.filters}
      // newFilters.priceRange = [parseInt(priceRange[0]/rate),parseInt(priceRange[1]/rate)]
      // props.userPack.filterMethods.handleFilters(newFilters)
      
      async function run(props){
        await setPriceRange([priceRange[0]/rate,priceRange[1]/rate])
        let filteredResults
        if (false){
          filteredResults = props.userPack.filteredResults
        }else{filteredResults = [...props.userPack.rawResults]}
        if(props.userPack.filters.sortBy){
          if(props.userPack.filters.sortBy==='high'){
            filteredResults = filteredResults.sort(highPriceComparator)
          }else{filteredResults = filteredResults.sort(lowPriceComparator)}
        }
        let newFilteredResults = []
        filteredResults.forEach(listing => {
          if(listing.dailyPrice*rate>priceRange[0]&&listing.dailyPrice*rate<priceRange[1]){
            newFilteredResults.push(listing)
          }
        });
        props.userPack.filterMethods.setFilteredResults(newFilteredResults)
      }
      run(props)
      // let filteredResults = props.userPack.results.sort(lowPriceComparator)
      // props.userPack.filterMethods.setFilteredResults(filteredResults)
    }
    const handleDeliveryFee=(e,deliveryFee)=>{
      setDeliveryFee(deliveryFee)
    }
    const open = props.userPack.filters.active?true:false
    const id = open ? 'simple-popover' : undefined;
    const selectedSymbol = props.userPack.elements.currency.symbols.filter(c=>c.value==props.userPack.elements.currency.selected)[0].label;

    const list = anchor => (
      <div
        className={clsx(classes.list, {
          [classes.fullList]: anchor === 'top' || anchor === 'bottom',
        })}
        role="presentation"
        onClick={toggleDrawer(false)}
        onKeyDown={toggleDrawer(false)}
      >
          <Grid container style={{height:props.userPack.dimensions.height*2/3+"px"}}>
            <List>
            {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (
                <ListItem button key={text}>
                <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
                <ListItemText primary={text} />
                </ListItem>
            ))}
            </List>
            <Divider />
            <List>
            {['All mail', 'Trash', 'Spam'].map((text, index) => (
                <ListItem button key={text}>
                <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
                <ListItemText primary={text} />
                </ListItem>
            ))}
            </List>
          </Grid>

      </div>
    );
    return(
        <>
        {props.userPack.dimensions.width>960?
        <>
        <Grid item xs={12}>
            <Divider/>
        </Grid>
        <Grid item xs={12} style={{height:"52px",overflow:"hidden"}}>
            <Grid container>

            <Grid item xs="auto" id="sortByFilter" className="popOverTrigger" style={{paddingRight:"10px",paddingTop:"10px",paddingBottom:"10px",paddingLeft:"15px"}}>
                <div id="customPopOver" style={{top:"115px",left:"15px"}}>
                  <Grid container>
                    <Grid item xs={12}>
                    <FormControlLabel
                    control={<Checkbox checked={props.userPack.filters.sortBy===null} onClick={filterRelevancia} name="checkedA" />}
                    label="Relevancia"
                  />
                    </Grid>
                    <Grid item xs={12}>
                    <FormControlLabel
                    control={<Checkbox checked={props.userPack.filters.sortBy==='low'} onClick={filterLowPrice} name="checkedA" />}
                    label="Precio: menor a mayor"
                  />                    
                      </Grid>
                    <Grid item xs={12}>
                    <FormControlLabel
                    control={<Checkbox checked={props.userPack.filters.sortBy==='high'} onClick={filterHighPrice} name="checkedA" />}
                    label="Precio: mayor a menor"
                  />                     
                    </Grid>
                  </Grid>



                </div>
                {props.userPack.filters.sortBy?
                  <Chip
                  deleteIcon={<DoneIcon style={{color:"green"}}/>}
                  clickable
                  id="sortBy"
                  label="ORDENAR POR"
                  />
                  :
                  <Chip
                  clickable
                  id="sortBy"
                  label="ORDENAR POR"
                  />
                  }
                      
            </Grid>

            <Grid item xs="auto" className="popOverTrigger" style={{padding:"10px"}}>
            <div id="customPopOver" style={{top:"115px",left:"150px"}}>
              <p style={{fontWeight:"bold",paddigBottom:"12px"}}>{selectedSymbol+parseInt(priceRange[0]*rate)+" - "+selectedSymbol+parseInt(priceRange[1]*rate)}</p>
                <AirbnbSlider
                  max={priceMaximum[1]*rate}
                  min={priceMaximum[0]*rate}
                  ThumbComponent={AirbnbThumbComponent}
                  getAriaLabel={(index) => (index === 0 ? 'Minimum price' : 'Maximum price')}
                  defaultValue={[parseInt(priceRange[0]*rate),parseInt(priceRange[1]*rate)]}
                  onChange={handlePrice}
                />
                    </div>
                  {props.userPack.filters.priceRange?
                    <Chip
                    deleteIcon={<DoneIcon style={{color:"green"}}/>}
                    label="PRECIO"
                    id="priceRange"
                    />
                    :
                  <Chip
                  clickable
                  id="priceRange"
                  label="PRECIO"
                  />
                  }


            </Grid>
            <Grid item xs="auto" className="popOverTrigger" style={{padding:"10px"}}>
            <div id="customPopOver" style={{top:"115px",left:"238px"}}>
            <p style={{fontWeight:"bold"}}>{"Gratis - "+selectedSymbol+deliveryFee}</p>
              <PrettoSlider max={100*rate} onChange={handleDeliveryFee} valueLabelDisplay="auto" aria-label="pretto slider" defaultValue={20*rate} />
                    </div>
                              {props.userPack.filters.deliveryFee?
                <Chip
                deleteIcon={<DoneIcon style={{color:"green"}}/>}
                label="ENTREGA"
                id="deliveryFee"/>
                :
                  <Chip
                  clickable
                  label="ENTREGA"
                  id="deliveryFee"
                  />
                  }

            </Grid>
            <Grid item xs="auto" className="popOverTrigger" style={{padding:"10px"}}>
            <div id="customPopOver" style={{top:"115px",right:props.userPack.dimensions.width<1140?props.userPack.dimensions.width/3+"px":"",left:props.userPack.dimensions.width<1140?"":"338px"}}>
                    <h1>Test</h1>
                    </div>
                              {props.userPack.filters.sortBy?
                              <Chip
                              id="otherFilters"
                              deleteIcon={<DoneIcon style={{color:"green"}}/>}
                              label="OTROS FILTROS"/>
                      
                  :
                  <Chip
                  clickable
                  id="otherFilters"
                  label="OTROS FILTROS"
                  />
                  }
                </Grid>
            <Grid item xs="auto" style={{padding:"10px"}}>
            <Chip
                    label="BORRAR"
                    onClick={handleClear}
                    clickable
                    />

            </Grid>
            </Grid>
        </Grid>
        <Grid item xs={12}>
            <Divider/>
        </Grid>
        </>:
    <>
    {['bottom'].map(anchor => (
       <React.Fragment key={anchor}>
       <SwipeableDrawer
         anchor={anchor}
         open={props.userPack.filters.active?props.userPack.filters.active:false}
         onClose={toggleDrawer(false)}
         onOpen={toggleDrawer(true)}
       >
         <div className="wide" style={{height:"95vh",boxSizing:"content-box"}}>
           <div className="wide t3 relative alignCenter">
            <div className="title1">Filtros</div>
            <div className="absolute" style={{right:"10px"}}>
              <div className="button" onClick={toggleDrawer(false)}>
              <CloseIcon/></div>
            </div>
           </div>
         <div className="l4 t5" style={{boxSizing:"content-box",width:"95%"}}>
           <div className="wide relative" style={{boxSizing:"content-box"}}>
           <div className="half button t4">
           <div>
             <div className="flexStart">
             <div className="alignCenter" style={{height:"32px",width:"32px"}}>
             <svg width="26" height="30" viewBox="0 0 26 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 0.599976C13 0.599976 18.4 4.19998 25.6 4.19998C25.6 24 13 29.4 13 29.4C13 29.4 0.400002 24 0.400002 4.19998C7.6 4.19998 13 0.599976 13 0.599976ZM13 15H22C22 15 23.8 13.2 23.8 5.99998C23.8 5.99998 14.8 4.19998 13 2.39998V15H4C5.8 22.2 13 27.6 13 27.6V15Z" fill="black"/>
</svg> </div>

                <div className="title2 l3">Marca y modelo</div>
             </div>
          </div>
              <div className="flexEnd r2">
                <div className="body2 r2">Todos</div>
                <div className="alignCenter">
                  <RightArrow/>
                </div>

              </div>

              </div>
              <div className="wide t3 r4" style={{boxSizing:"content-box"}}>
              <div className="hrElement r4" style={{boxSizing:"content-box"}}></div>
              </div>
           </div>
           <div className="wide relative" style={{boxSizing:"content-box"}}>
           <div className="half button t4">
           <div>
             <div className="flexStart">
             <div className="alignCenter" style={{height:"32px",width:"32px"}}>
             <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.7664 27.5444L27.2903 12.0294C28.3114 10.6519 27.9738 8.66968 26.5316 7.60357L26.366 7.48077L26.4129 7.41748C27.5942 5.82573 27.1951 3.52965 25.5201 2.28944L25.0438 1.93783C23.3704 0.697383 21.0544 0.985188 19.8731 2.57694L19.8248 2.64209L19.516 2.41466C18.0771 1.34807 16.0787 1.59864 15.0546 2.97819L3.53075 18.4932C2.50807 19.8709 2.84778 21.8562 4.28779 22.9193L11.3036 28.1098C12.746 29.1775 14.7424 28.924 15.7664 27.5444V27.5444ZM18.9087 7.15606C18.7001 5.75261 19.7209 4.43981 21.1903 4.21816C22.6586 3.99999 24.0174 4.96253 24.2259 6.36598C24.4344 7.76943 23.4114 9.07761 21.9454 9.3004C20.4748 9.51395 19.1167 8.55627 18.9087 7.15606ZM8.25874 23.6477L9.75607 21.6297C8.84872 20.6846 8.41538 19.3957 8.64349 18.1775C8.66805 18.0388 8.72061 17.9065 8.79795 17.7888C8.87529 17.6711 8.97579 17.5704 9.09334 17.4928C9.21411 17.4118 9.35007 17.3561 9.49298 17.3292C9.63589 17.3023 9.78278 17.3046 9.92476 17.3361C10.2082 17.3962 10.4573 17.5639 10.6196 17.8039C10.782 18.0439 10.8449 18.3376 10.7951 18.623C10.7195 19.0285 10.8417 19.4608 11.0885 19.8399L12.8256 17.5064C11.4908 16.1261 11.2184 14.0696 12.2817 12.6312C13.3536 11.1833 15.4077 10.8499 17.1153 11.7408L18.5822 9.76369L19.7531 10.6316L18.2845 12.6205C19.1901 13.5758 19.6237 14.8663 19.3942 16.0864C19.3675 16.2271 19.3128 16.3609 19.2332 16.4799C19.1537 16.5989 19.0509 16.7007 18.9311 16.7791C18.8114 16.8575 18.677 16.911 18.5361 16.9363C18.3952 16.9616 18.2506 16.9582 18.1111 16.9264C17.8285 16.8635 17.5809 16.6946 17.4192 16.4545C17.2575 16.2144 17.194 15.9215 17.2419 15.636C17.3191 15.2303 17.1989 14.8009 16.9572 14.4228L15.224 16.7707C16.5298 18.1452 16.7873 20.1791 15.7306 21.6066C14.6722 23.0343 12.6602 23.383 10.9737 22.5337L9.48997 24.5431L8.25874 23.6477Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.0378 13.9936C13.6696 14.4922 13.7278 15.1958 14.1247 15.7713L15.772 13.5587C15.1026 13.3451 14.409 13.4929 14.0378 13.9936V13.9936Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.9335 20.3034C14.2911 19.8229 14.2459 19.1505 13.8838 18.5865L12.2814 20.7559C12.9229 20.9372 13.5791 20.7834 13.9335 20.3034V20.3034Z" fill="black"/>
</svg>
 </div>

                <div className="title2 l3">Precio</div>
             </div>
          </div>
              <div className="flexEnd r2">
                <div className="body2 r2">Todos</div>
                <div className="alignCenter">
                  <RightArrow/>
                </div>

              </div>

              </div>
              <div className="wide t3 r4" style={{boxSizing:"content-box"}}>
              <div className="hrElement r4" style={{boxSizing:"content-box"}}></div>
              </div>
           </div>
           <div className="wide relative" style={{boxSizing:"content-box"}}>
           <div className="half button t4">
           <div>
             <div className="flexStart">
             <div className="alignCenter" style={{height:"32px",width:"32px"}}>
             <svg width="31" height="22" viewBox="0 0 31 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M30.8877 12.3901C30.6552 9.61194 30.2722 9.07087 30.1275 8.86737C29.7948 8.39712 29.2626 8.08981 28.6993 7.76737C28.6675 7.74945 28.64 7.72389 28.619 7.69271C28.598 7.66154 28.5841 7.6256 28.5784 7.58773C28.5727 7.54986 28.5754 7.51111 28.5862 7.47451C28.5969 7.43792 28.6156 7.4045 28.6406 7.37688C28.7449 7.26428 28.825 7.12898 28.8755 6.98028C28.9261 6.83158 28.9457 6.673 28.9332 6.51544C28.9089 6.23605 28.7868 5.97657 28.5912 5.78848C28.3956 5.6004 28.1407 5.49743 27.8771 5.5H26.8694C26.8262 5.50027 26.7831 5.50326 26.7402 5.50894C26.7108 5.49536 26.6804 5.48454 26.6492 5.47663C26.0523 4.13394 25.2352 2.29556 23.5416 1.39837C21.0296 0.0687497 16.4022 0 15.4979 0C14.5936 0 9.96613 0.0687499 7.45734 1.39631C5.76372 2.2935 4.94662 4.13188 4.34978 5.47456L4.34461 5.48556C4.31485 5.49002 4.28561 5.49786 4.25741 5.50894C4.21455 5.50326 4.17142 5.50027 4.12823 5.5H3.11864C2.85503 5.49743 2.60014 5.6004 2.40452 5.78848C2.2089 5.97657 2.08684 6.23605 2.06255 6.51544C2.05108 6.67263 2.07163 6.83061 2.1228 6.97857C2.17396 7.12653 2.25455 7.26099 2.35903 7.37275C2.38403 7.40037 2.40265 7.4338 2.41343 7.47039C2.42422 7.50698 2.42686 7.54574 2.42116 7.58361C2.41546 7.62147 2.40157 7.65741 2.38059 7.68859C2.35961 7.71976 2.3321 7.74532 2.30025 7.76325C1.737 8.08775 1.20217 8.39506 0.872103 8.86325C0.727415 9.0695 0.345026 9.60781 0.111845 12.386C-0.0173402 13.9494 -0.036718 15.5678 0.0646927 16.61C0.277203 18.7756 0.675741 20.0846 0.692535 20.1389C0.753691 20.3366 0.866264 20.5117 1.01718 20.644C1.16811 20.7763 1.35118 20.8603 1.54516 20.8862V20.9C1.54516 21.1917 1.65405 21.4715 1.84786 21.6778C2.04168 21.8841 2.30455 22 2.57865 22H6.19584C6.46994 22 6.73281 21.8841 6.92663 21.6778C7.12045 21.4715 7.22933 21.1917 7.22933 20.9C7.78547 20.9 8.17239 20.7941 8.58255 20.6814C9.17473 20.5115 9.78002 20.3986 10.3911 20.3438C12.3619 20.1438 14.3216 20.075 15.4979 20.075C16.6502 20.075 18.6965 20.1438 20.6705 20.3438C21.284 20.3987 21.8917 20.5121 22.4862 20.6828C22.8789 20.79 23.2516 20.889 23.7677 20.8993C23.7677 21.1911 23.8766 21.4708 24.0704 21.6771C24.2642 21.8834 24.5271 21.9993 24.8012 21.9993H28.4184C28.6925 21.9993 28.9553 21.8834 29.1491 21.6771C29.343 21.4708 29.4518 21.1911 29.4518 20.8993V20.8911C29.6463 20.8656 29.8299 20.7818 29.9813 20.6495C30.1327 20.5172 30.2457 20.3418 30.3071 20.1438C30.3239 20.0894 30.7224 18.7804 30.9349 16.6148C31.0363 15.5719 31.0182 13.9563 30.8877 12.3901ZM6.21781 6.41506C6.73455 5.24631 7.32557 3.92356 8.37779 3.366C9.89831 2.56025 13.0498 2.19725 15.4979 2.19725C17.9459 2.19725 21.0974 2.5575 22.6179 3.366C23.6701 3.92356 24.2586 5.247 24.7779 6.41506L24.8425 6.56425C24.8803 6.64918 24.897 6.743 24.891 6.83675C24.885 6.9305 24.8566 7.02106 24.8084 7.09979C24.7602 7.17852 24.6939 7.2428 24.6157 7.28649C24.5376 7.33018 24.4502 7.35183 24.3619 7.34937C22.2155 7.2875 17.694 7.0895 15.4979 7.0895C13.3017 7.0895 8.7802 7.29231 6.63056 7.35419C6.5423 7.35664 6.45493 7.33499 6.37677 7.2913C6.29861 7.24761 6.23227 7.18333 6.18408 7.1046C6.13589 7.02587 6.10745 6.93531 6.10148 6.84156C6.09551 6.74781 6.11221 6.65399 6.14998 6.56906C6.17259 6.51819 6.19649 6.46662 6.21781 6.41506ZM6.9884 11.8896C5.87728 12.032 4.75905 12.1022 3.63991 12.1C2.95522 12.1 2.24922 11.8937 2.1181 11.2447C2.02831 10.8082 2.038 10.5628 2.08645 10.3159C2.12714 10.1063 2.19173 9.95363 2.5147 9.9C3.35441 9.7625 3.824 9.93506 5.19853 10.3661C6.10994 10.6514 6.76749 11.0316 7.14213 11.3328C7.33009 11.4813 7.22998 11.869 6.9884 11.8896ZM21.288 17.5271C20.4379 17.6303 18.7378 17.5924 15.5172 17.5924C12.2966 17.5924 10.5972 17.6303 9.74716 17.5271C8.86999 17.4233 7.75189 16.5406 8.51537 15.7541C9.02372 15.2357 10.2096 14.8479 11.7889 14.63C13.3682 14.4121 14.0368 14.3 15.5108 14.3C16.9848 14.3 17.5855 14.3687 19.2326 14.6307C20.8797 14.8926 22.1244 15.2852 22.5062 15.7548C23.2025 16.5963 22.1645 17.4178 21.288 17.5313V17.5271ZM28.8776 11.2441C28.7484 11.8958 28.0379 12.0993 27.3558 12.0993C26.2152 12.0996 25.0756 12.0294 23.9427 11.8889C23.7451 11.869 23.6533 11.4998 23.8536 11.3321C24.2224 11.0234 24.8871 10.6508 25.7972 10.3654C27.1717 9.93438 27.9643 9.76181 28.6451 9.9055C28.8111 9.94056 28.8989 10.1303 28.9093 10.2493C28.9548 10.5804 28.9441 10.9169 28.8776 11.2441Z" fill="black"/>
</svg>
</div>

                <div className="title2 l3">Estilo</div>
             </div>
          </div>
              <div className="flexEnd r2">
                <div className="body2 r2">Todos</div>
                <div className="alignCenter">
                  <RightArrow/>
                </div>

              </div>

              </div>
              <div className="wide t3 r4" style={{boxSizing:"content-box"}}>
              <div className="hrElement r4" style={{boxSizing:"content-box"}}></div>
              </div>
           </div>
           <div className="wide relative" style={{boxSizing:"content-box"}}>
           <div className="half button t4">
           <div>
             <div className="flexStart">
             <div className="alignCenter" style={{height:"32px",width:"32px"}}>
             <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 0.571411C18.1543 0.571411 23.1429 5.55998 23.1429 11.7143C23.1429 16.4228 19.8343 21.5543 13.3029 27.1634C12.9397 27.4754 12.4766 27.6467 11.9979 27.6463C11.5191 27.6459 11.0563 27.4737 10.6937 27.1611L10.2617 26.7863C4.01943 21.3234 0.857147 16.3177 0.857147 11.7143C0.857147 5.55998 5.84572 0.571411 12 0.571411ZM12 7.42855C10.8634 7.42855 9.77327 7.88008 8.96955 8.68381C8.16582 9.48754 7.71429 10.5776 7.71429 11.7143C7.71429 12.8509 8.16582 13.941 8.96955 14.7447C9.77327 15.5485 10.8634 16 12 16C13.1366 16 14.2267 15.5485 15.0305 14.7447C15.8342 13.941 16.2857 12.8509 16.2857 11.7143C16.2857 10.5776 15.8342 9.48754 15.0305 8.68381C14.2267 7.88008 13.1366 7.42855 12 7.42855Z" fill="black"/>
</svg>
 </div>

                <div className="title2 l3">Ubicación</div>
             </div>
          </div>
              <div className="flexEnd r2">
                <div className="body2 r2">Todos</div>
                <div className="alignCenter">
                  <RightArrow/>
                </div>

              </div>

              </div>
              <div className="wide t3 r4" style={{boxSizing:"content-box"}}>
              <div className="hrElement r4" style={{boxSizing:"content-box"}}></div>
              </div>
           </div>

           </div>
         </div>
       </SwipeableDrawer>
     </React.Fragment>
    ))}
    </>
    }
        </>
    )
}